import { useQuery } from "@tanstack/react-query";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

type Call = {
  id: string; status: string; direction: string; callerName?: string; callerPhone?: string;
  queueName?: string; agentName?: string; startedAt?: string; endedAt?: string; durationSec?: number;
  disposition?: string;
};

export default function CallLogs() {
  const calls = useQuery<Call[]>({ queryKey: ["/api/calls"] });
  const data = calls.data || [];

  return (
    <div className="p-4 sm:p-6 max-w-7xl mx-auto space-y-4" data-testid="page-call-logs">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">Call Logs</h1>
        <p className="text-sm text-muted-foreground">All recent call sessions.</p>
      </div>
      <Card>
        <CardHeader><CardTitle className="text-sm">Sessions ({data.length})</CardTitle></CardHeader>
        <CardContent>
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="text-left text-xs text-muted-foreground border-b">
                  <th className="py-2 pr-2">Caller</th>
                  <th className="py-2 pr-2 hidden sm:table-cell">Direction</th>
                  <th className="py-2 pr-2 hidden md:table-cell">Queue</th>
                  <th className="py-2 pr-2 hidden md:table-cell">Agent</th>
                  <th className="py-2 pr-2">Status</th>
                  <th className="py-2 pr-2 hidden lg:table-cell">Started</th>
                  <th className="py-2 pr-2 hidden lg:table-cell">Duration</th>
                </tr>
              </thead>
              <tbody>
                {data.map(c => (
                  <tr key={c.id} className="border-b" data-testid={`row-log-${c.id}`}>
                    <td className="py-2 pr-2">
                      <div className="font-medium truncate">{c.callerName || c.callerPhone}</div>
                      <div className="text-xs text-muted-foreground sm:hidden">{c.direction}</div>
                    </td>
                    <td className="py-2 pr-2 hidden sm:table-cell">{c.direction}</td>
                    <td className="py-2 pr-2 hidden md:table-cell">{c.queueName || "—"}</td>
                    <td className="py-2 pr-2 hidden md:table-cell">{c.agentName || "—"}</td>
                    <td className="py-2 pr-2"><Badge variant="outline">{c.status}</Badge></td>
                    <td className="py-2 pr-2 hidden lg:table-cell">{c.startedAt && new Date(c.startedAt).toLocaleString()}</td>
                    <td className="py-2 pr-2 hidden lg:table-cell">{c.durationSec ? `${c.durationSec}s` : "—"}</td>
                  </tr>
                ))}
                {data.length === 0 && <tr><td colSpan={7} className="text-center py-8 text-muted-foreground text-xs">No calls yet.</td></tr>}
              </tbody>
            </table>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
